import { effect, inject, Injectable, signal } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { FILTER_PATTERNS } from '@shared/constants';
import { isPasswordMatch } from '../validators/is-password-match.validator';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Injectable()
export class RegisterModalFormService {
  private readonly _fb = inject(NonNullableFormBuilder);

  private readonly _sending = signal(false);
  public readonly sending = this._sending.asReadonly();

  public setIsSending(value: boolean) {
    this._sending.set(value);
  }

  public readonly registerForm = this._fb.group(
    {
      email: this._fb.control<string>('', {
        validators: [
          Validators.required,
          Validators.pattern(FILTER_PATTERNS.email),
        ],
      }),
      password: this._fb.control<string>('', {
        validators: [Validators.required, Validators.minLength(8)],
      }),
      confirm_password: this._fb.control<string>('', {
        validators: [Validators.required],
      }),
      first_name: this._fb.control<string>('', {
        validators: [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern(FILTER_PATTERNS.name),
        ],
      }),
      middle_name: this._fb.control<string>('', {
        validators: [Validators.pattern(FILTER_PATTERNS.name)],
      }),
      last_name: this._fb.control<string>('', {
        validators: [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern(FILTER_PATTERNS.name),
        ],
      }),
      phone_number: this._fb.control<string>('', {
        validators: [Validators.pattern(FILTER_PATTERNS.phoneNumber)],
      }),
      prefix_phone: this._fb.control<string>(DEFAULT_USA_PHONE_PREFIX),
      is_firm: this._fb.control<boolean>(false),
    },
    {
      validators: [isPasswordMatch()],
    },
  );

  public readonly isFirm = toSignal(
    this.registerForm.controls.is_firm.valueChanges.pipe(
      map((value) => !!value),
    ),
    {
      initialValue: false,
    },
  );

  constructor() {
    effect(() => {
      if (this.isFirm()) {
        this.registerForm.controls.last_name.disable();
        this.registerForm.controls.middle_name.disable();

        this.registerForm.controls.last_name.setValue('');
        this.registerForm.controls.middle_name.setValue('');
      } else {
        this.registerForm.controls.last_name.enable();
        this.registerForm.controls.middle_name.enable();
      }
    });
  }
}
